import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import Floating from '@/sections/Floating';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { FILES } from '@/constants/files';
import { useRouter } from 'next/router';
export function Benefits() {
  const $ = _c(65);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["extendedWarranty"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><div className="bgCircle absolute right-0 bottom-0 hidden translate-x-2/3 translate-y-10 lg:block" /><div className="bgCircle absolute top-1/3 left-0 hidden -translate-x-1/4 -translate-y-1/3 rotate-180 lg:block" /></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("benefits.items.1.text");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("benefits.items.1.title");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("benefits.items.1.title");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      alt: t4,
      src: "/images/sections/extendedWarranty/benefits/1.png"
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
    t6 = {
      anchorKey: "benefits.items.1.title",
      content: t2,
      title: t3,
      image: t5,
      variant: "small"
    };
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== locale) {
    t7 = FILES(locale);
    $[14] = locale;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7.insuranceTerms) {
    t8 = <Link analyticsParam="extendedWarrantyInsuranceTerms" testId="extendedWarrantyInsuranceTerms" to={t7.insuranceTerms} target="_blank" />;
    $[16] = t7.insuranceTerms;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t || $[19] !== t8) {
    t9 = <Trans t={t} i18nKey="benefits.items.2.text">{t8}</Trans>;
    $[18] = t;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("benefits.items.2.title");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("benefits.items.2.title");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = {
      alt: t11,
      src: "/images/sections/extendedWarranty/benefits/2.png"
    };
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12 || $[29] !== t9) {
    t13 = {
      anchorKey: "benefits.items.2.title",
      content: t9,
      title: t10,
      image: t12,
      imagePosition: "right",
      variant: "small"
    };
    $[27] = t10;
    $[28] = t12;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== locale) {
    t14 = FILES(locale);
    $[31] = locale;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14.insuranceTerms) {
    t15 = <Link analyticsParam="extendedWarrantyInsuranceTerms" testId="extendedWarrantyInsuranceTerms" to={t14.insuranceTerms} target="_blank" />;
    $[33] = t14.insuranceTerms;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t || $[36] !== t15) {
    t16 = <Trans t={t} i18nKey="benefits.items.3.text">{t15}</Trans>;
    $[35] = t;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("benefits.items.3.title");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t) {
    t18 = t("benefits.items.3.title");
    $[40] = t;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t18) {
    t19 = {
      alt: t18,
      src: "/images/sections/extendedWarranty/benefits/3.png"
    };
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t16 || $[45] !== t17 || $[46] !== t19) {
    t20 = {
      anchorKey: "benefits.items.3.title",
      content: t16,
      title: t17,
      image: t19,
      variant: "small"
    };
    $[44] = t16;
    $[45] = t17;
    $[46] = t19;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t13 || $[49] !== t20 || $[50] !== t6) {
    t21 = [t6, t13, t20];
    $[48] = t13;
    $[49] = t20;
    $[50] = t6;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t) {
    t22 = t("benefits.title");
    $[52] = t;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t) {
    t23 = t("benefits.cta");
    $[54] = t;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== locale) {
    t24 = LINKS(locale);
    $[56] = locale;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== t23 || $[59] !== t24.insurance) {
    t25 = {
      analyticsParam: "extendedWarrantyInsurance",
      testId: "extendedWarrantyInsurance",
      text: t23,
      to: t24.insurance
    };
    $[58] = t23;
    $[59] = t24.insurance;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t21 || $[62] !== t22 || $[63] !== t25) {
    t26 = <Floating bgCircles={t1} boxes={t21} title={t22} button={t25} />;
    $[61] = t21;
    $[62] = t22;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  return t26;
}